import { registerLocale } from 'react-datepicker';

import caLocale from 'date-fns/locale/ca';
import csLocale from 'date-fns/locale/cs';
import deLocale from 'date-fns/locale/de';
import elLocale from 'date-fns/locale/el';
import enLocale from 'date-fns/locale/en-GB';
import esLocale from 'date-fns/locale/es';
import euLocale from 'date-fns/locale/eu';
import frLocale from 'date-fns/locale/fr';
import glLocale from 'date-fns/locale/gl';
import hrLocale from 'date-fns/locale/hr'; // croatian
import huLocale from 'date-fns/locale/hu'; // hungarian
import itLocale from 'date-fns/locale/it';
import plLocale from 'date-fns/locale/pl';
import ptLocale from 'date-fns/locale/pt';
import roLocale from 'date-fns/locale/ro'; // romanian
import skLocale from 'date-fns/locale/sk';
import slLocale from 'date-fns/locale/sl'; // slovanian
import srLocale from 'date-fns/locale/sr'; // serbian
import trLocale from 'date-fns/locale/tr'; // turkish
import ukLocale from 'date-fns/locale/uk'; // ukrainian

const dateFnsLocaleData = {
  ca: caLocale, // catalan
  cs: csLocale, // czech
  de: deLocale, // german
  el: elLocale, // estonian
  en: enLocale, // english
  es: esLocale, // spanish
  eu: euLocale, // basque
  fr: frLocale, // french
  gl: glLocale, // galician
  hr: hrLocale, // croatian
  hu: huLocale, // hungarian
  it: itLocale, // italian
  pl: plLocale, // polish
  pt: ptLocale, // portuguese
  ro: roLocale, // romanian
  sk: skLocale, // slovak
  sl: slLocale, // slovanian
  sr: srLocale, // serbian
  tr: trLocale, // turkish
  uk: ukLocale, // ukrainian
};

export const getDateFnsLocaleData = language => dateFnsLocaleData[language];
export const addRegisterLocale = langage => registerLocale(langage, dateFnsLocaleData[langage]);
